<template>
  <nav class="about__header">
    <img class="about__header__logo" src="@/assets/img/logo.png" alt="logo" />
  </nav>
</template>

<script>
export default {
  name: 'Header'
}
</script>



// WEBPACK FOOTER //
// src/app/about/Header.vue